export const Hero = () => (
  <header className="py-24 md:py-32 px-6 border-b border-[#1C2C4E] relative overflow-hidden">
    <div className="max-w-6xl mx-auto">
      <div className="inline-flex items-center gap-2 px-3 py-1 rounded bg-[#1C2C4E]/60 border border-[#2C4066] text-[#51ADDA] font-mono text-xs tracking-widest uppercase mb-8">
        <span className="w-2 h-2 rounded-full bg-[#51ADDA] animate-pulse"></span>
        Laboratoire Électronique Automobile France
      </div>

      <h1 className="font-display text-[clamp(28px,8vw,110px)] uppercase tracking-tight text-white leading-[0.95] mb-8">
        <span className="ln"><span>Reprogrammation et clonage</span></span>
        <span className="ln"><span className="text-[#51ADDA]">de calculateurs moteur certifiés.</span></span>
      </h1>

      <div className="fade-sub max-w-xl text-slate-300 text-lg leading-relaxed mb-10">
        Travail garanti et testé avant renvoi postal dans toute la France avec devis express et paiement par carte sécurisé.
        <span className="block mt-2 text-sm text-[#51ADDA] font-mono">Devis envoyé à : bellahcen.youness@gmail.com</span>
      </div>

      <div className="flex flex-wrap items-center gap-4">
        <a
          href="#devis"
          data-testid="hero-configure-cta"
          className="bg-[#EF3340] text-white font-display uppercase tracking-wider text-lg px-8 py-4 rounded hover:bg-[#f87171] transition-colors shadow-lg shadow-[#EF3340]/20"
        >
          Configurer mon calculateur
        </a>
        <div className="flex items-center gap-3 px-4 py-3 rounded border border-[#1C2C4E] text-xs font-mono text-slate-400">
          <span className="text-emerald-400">●</span> Banc de test officiel • Réponse{" "}
          <span className="odo"><span className="reel" style={{ "--d": 2 }}>0<br />1<br />2<br />3<br />4</span></span>h
        </div>
      </div>
    </div>
  </header>
);
